import React from 'react';

export const MCSACyberOracle = () => {
    return (
        <iframe
            title="Cyber Oracle"
            src="/mcsa_htmls__TBD/cyber_oracle.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
